<template>
  <div class="pc-list" ref="list">
    <h2>翻译词库管理</h2>
    <br />
    <thesaurusManagementSearch @search="search" />
    <div class="pc-head">
      <div class="pc-head-handle">
        <div class="pc-head-btn">
          <button @click="addWord">添加</button>
        </div>
        <p>{{ "共" + pagination_options.total + "条" }}</p>
      </div>
    </div>

    <el-table
      class="pc-list-table"
      @sort-change="changeSort"
      :data="competitionList"
    >
      <el-table-column
        fixed="left"
        prop="id"
        label="编号"
        sortable="custom"
        width="150"
      ></el-table-column>
      <el-table-column
        fixed="left"
        prop="chinese_word"
        label="原词"
        width="250"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.chinese_word ? scope.row.chinese_word : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        fixed="left"
        prop="english_word"
        label="机器翻译词"
        width="250"
      >
        <template slot-scope="scope">
          <div>
            {{ scope.row.english_word ? scope.row.english_word : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column label="翻译模式" prop="translate_type" width="250">
        <template slot-scope="scope">
          <div>
            {{ scope.row.translate_type == 1 ? "中译英" : "英译中" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column fixed="left" prop="pro_word" label="翻译词" width="250">
        <template slot-scope="scope">
          <div>
            {{ scope.row.pro_word ? scope.row.pro_word : "暂无" }}
          </div>
        </template>
      </el-table-column>
      <el-table-column width="250">
        <template slot-scope="scope">
          <button class="btnViewDetail" @click="deleteDetail(scope.row)">
            删除
          </button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      class="designerDialog"
      :title="wordDetail.source_word"
      :visible.sync="dialogFormVisible"
      width="30%"
    >
      <el-form label-width="80px">
        <el-form-item label="原词">
          <el-input v-model="wordDetail.source_word" placeholder="请输入原词">
          </el-input>
        </el-form-item>
        <el-form-item label="翻译词">
          <el-input
            v-model="wordDetail.pro_word"
            placeholder="请输入翻译词"
          ></el-input>
        </el-form-item>
        <el-form-item label="翻译模式">
          <el-select
            v-model="wordDetail.translate_type"
            clearable
            placeholder="翻译模式"
          >
            <el-option label="中译英" value="1"></el-option>
            <el-option label="英译中" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          class="dialog-footer-button-one"
          @click="dialogFormVisible = false"
          >取 消</el-button
        >
        <el-button
          class="dialog-footer-button-second"
          type="primary"
          @click="submitDialog(wordDetail)"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <DeleteHint
      :dialogVisible="deleteDialogVisible"
      @cancel="closeDelete"
      @delete="isDelete"
    />
    <Pagination
      v-if="competitionList.length > 0"
      :pagination="pagination_options"
      @goPage="goPage"
    />
  </div>
</template>

<script>
import Pagination from "@/components/componentSet/Pagination";
import thesaurusManagementSearch from "../components/thesaurusManagementSearch";
import DeleteHint from "@/components/template/DeleteHint";
import {
  translateLibrary_Api,
  deleteTranslateLibrary_Api,
  createTranslateLibrary_Api,
} from "@/apis/word.api";
export default {
  components: {
    thesaurusManagementSearch,
    Pagination,
    DeleteHint,
  },
  data() {
    return {
      loading: false,
      deleteDialogVisible: false,
      dialogFormVisible: false,
      isActive: null,
      searchRules: {
        page: 1,
        page_size: 10,
        keyword: "",
      },
      wordDetail: {
        source_word: "",
        pro_word: "",
        translate_type: null,
      },
      pagination_options: {
        page: 1,
        total: 0,
        take: 10,
      },
      competitionList: [],
      word_id: null,
      checked: [],
    };
  },
  filters: {
    scholarname: function (value) {
      for (let i in value) {
        return value.toString();
      }
    },
  },
  mounted() {
    this.getCompetitionListByRules(this.searchRules);
  },
  methods: {
    // 获取
    getCompetitionListByRules(data) {
      this.loading = true;
      translateLibrary_Api(this.searchRules.keyword)
        .then((res) => {
          console.log(res);
          this.$set(this.pagination_options, "total", res.data.length);
          this.competitionList = res.data;
          this.loading = false;
          this.$global.success(this, "获取成功", null);
        })
        .catch(() => {
          this.loading = false;
          this.$global.error(this, "获取失败！", null);
        });
    },
    // 排序
    changeSort(val) {
      if (val.order == "ascending") {
        this.searchRules.order = "+" + val.prop;
      }
      if (val.order == "descending") {
        this.searchRules.order = "-" + val.prop;
      }
      if (val.order == null) {
        this.searchRules.order = "-id";
      }
      this.searchRules.page = 1;
      let data = this.dealSearchRules(this.searchRules);
      this.getCompetitionListByRules(data);
      this.pagination_options.page = 1;
    },
    deleteDetail(item) {
      console.log(item);
      this.word_id = item.id;
      this.deleteDialogVisible = true;
    },
    search(formData) {
      console.log(formData);
      this.searchRules = { ...this.searchRules, page: 1, ...formData };
      let data = this.dealSearchRules(this.searchRules);
      console.log(this.searchRules);
      this.getCompetitionListByRules(data);
      this.pagination_options.page = 1;
    },
    dealSearchRules(formData) {
      let data = {};
      if (formData.page) {
        data.page = formData.page;
      }
      if (formData.page_size) {
        data.page_size = formData.page_size;
      }
      if (formData.order) {
        data.order = formData.order;
      }
      if (formData.keyword) {
        data.keyword = formData.keyword;
      }
      return data;
    },
    isDelete() {
      deleteTranslateLibrary_Api({ word_id: this.word_id }).then((res) => {
        if (res.code == 205) {
          this.$global.success(this, "删除成功！");
          this.deleteDialogVisible = false;
          this.getCompetitionListByRules(this.searchRules);
        } else {
          this.$global.error(this, "删除失败！");
          return;
        }
      });
    },
    closeDelete() {
      this.deleteDialogVisible = false;
    },
    addWord() {
      this.dialogFormVisible = true;
    },
    submitDialog() {
      createTranslateLibrary_Api(this.wordDetail).then((res) => {
        if (res.code == 205) {
          this.$global.success(this, "创建成功");
          this.dialogFormVisible = false;
          this.getCompetitionListByRules(this.searchRules);
        } else {
          this.$global.erroe(this, "创建失败");
          return;
        }
      });
    },
    goPage(pageNo) {
      this.pagination_options.page = pageNo;
      this.searchRules.page = pageNo;
      let data = this.dealSearchRules(this.searchRules);
      this.getCompetitionListByRules(data);
    },
  },
};
</script>



<style lang="scss" scoped>
/deep/ .el-dialog__footer {
  .dialog-footer-button-one {
    @include manage-button;
    background: $test;
    color: $blueBtna;
  }
  .dialog-footer-button-second {
    @include manage-button;
  }
}
.pc-list {
  @include table-head;
  h2 {
    font-size: 20px;
    color: $mainTitle;
    align-self: flex-end;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/admin/content/components/thesaurusManagementTable.vue